export default __webpack_public_path__ + "static/media/rocket-nitijana.059728cd.png";